import { type CSSProperties } from 'react';
import { FormattedMessage } from 'react-intl';

import RestClient from '../../network/axios';

import errorImage from './assets/error-404.png';
import msg from './messages';

const errorWrapperStyles: CSSProperties = {
  padding: '8px',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
};

type ErrorComponentProps = { error?: unknown };

const toErrorMessage = (value: unknown): string => {
  if (typeof value === 'string') {
    return value;
  }
  if (value && typeof value === 'object' && 'message' in value) {
    const message = (value as { message?: unknown }).message;
    return typeof message === 'string' ? message : '';
  }
  return '';
};

const ErrorComponent = ({ error }: ErrorComponentProps) => {
  const errorMessage = toErrorMessage(error);
  const altText: string = errorMessage || 'error';
  const imageSrc: string = errorImage as string;
  return (
    <>
      <style>
        {`
          .error-img {
            max-width: 50%;
            width: 100%;
            height: auto;
          }
          @media (max-width: 600px) {
            .error-img {
              max-width: 65%;
            }
          }
          @media (max-width: 480px) {
            .error-img {
              max-width: 100%;
            }
          }
        `}
      </style>
      <div style={errorWrapperStyles}>
        <h6
          style={{ textAlign: 'center', fontSize: '1.25rem', fontWeight: 500, margin: '0 0 16px' }}
        >
          {errorMessage}
        </h6>
        <img alt={altText} src={imageSrc} className='error-img' />
        <p style={{ textAlign: 'center', margin: '16px 0' }}>
          <FormattedMessage {...msg.errorSubHeading} />
        </p>
        <p style={{ textAlign: 'center', marginBottom: '16px' }}>
          <FormattedMessage {...msg.errorDisplayText} />
          <br />
        </p>
        <p style={{ textAlign: 'center', margin: '0' }}>
          Correlation ID: {RestClient.getCorrelationId()}
        </p>
      </div>
    </>
  );
};

export default ErrorComponent;
